import FileEditableMeta from './FileEditableMeta';

export default FileEditableMeta;
